// eslint-disable-next-line import/prefer-default-export
export { default as withLinkElement } from './withLinkElement';
